import { IProductFilter } from '../../constants/product/productFilter.constant';
import { createURLSearchParams } from '../creator/createURLSearchParams.util';
import { createProductFilterSearchParams } from './createProductFilterSearchParams.util';

export const createSearchParamBySelectedFilterOption = (filters: IProductFilter[]): string => {
  const searchParam = createProductFilterSearchParams({ filters });
  return createURLSearchParams(searchParam);
};
